module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsSAAALEgHS3X78AAAAoUlEQVQ4y81TQQqEMAycir9Ip+zP3J9Yf9KnSeg/shcrXRW39rQDISQMw6RNHCkRwIx2LKo57hUpRkoyM5DyusolSEmkWN1DaZDyJmU95pq88a4FWhwUgSqiI8XwEKrZheATgOlk6VccHNuIDoTgd9dDj4BqdqrZdQvU+BOB7UtaHu/EGwEsAOYQ/NR6C1/V3Zq27MTQYvNuHGdmdfPxaX8AeeXT4qqKbTcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Windows.png
// module id = 144
// module chunks = 0 1